module.exports = __webpack_public_path__ + "img/AttachementIcon.88bd3d6d.svg";